import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "evse" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "first-column-with-icon-type" }
const _hoisted_6 = { class: "name-type-block" }
const _hoisted_7 = { class: "name-data" }
const _hoisted_8 = { class: "first-column-with-icon-type" }
const _hoisted_9 = { class: "name-type-block" }
const _hoisted_10 = { class: "name-data" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "first-column-with-icon-type" }
const _hoisted_13 = { class: "name-type-block" }
const _hoisted_14 = { class: "name-data" }
const _hoisted_15 = {
  key: 0,
  class: "first-column-with-icon-type"
}
const _hoisted_16 = { class: "name-type-block" }
const _hoisted_17 = { class: "name-data" }
const _hoisted_18 = {
  key: 1,
  class: "first-column-with-icon-type"
}
const _hoisted_19 = { class: "name-type-block" }
const _hoisted_20 = { class: "first-column-with-icon-type" }
const _hoisted_21 = { class: "name-type-block" }
const _hoisted_22 = {
  key: 0,
  class: "type-data-block"
}
const _hoisted_23 = {
  key: 1,
  class: "type-data-block"
}
const _hoisted_24 = {
  key: 2,
  class: "type-data-block"
}
const _hoisted_25 = {
  key: 3,
  class: "type-data-block"
}
const _hoisted_26 = { class: "first-column-with-icon-type" }
const _hoisted_27 = { class: "name-type-block" }
const _hoisted_28 = { class: "type-data-block" }
const _hoisted_29 = { class: "type-data-block" }
const _hoisted_30 = { class: "type-data-block" }
const _hoisted_31 = { class: "first-column-with-icon-type" }
const _hoisted_32 = { class: "name-type-block" }
const _hoisted_33 = { class: "type-data-block" }
const _hoisted_34 = { class: "type-data-block" }
const _hoisted_35 = {
  key: 0,
  class: "type-data-block"
}
const _hoisted_36 = {
  key: 1,
  class: "type-data-block"
}
const _hoisted_37 = { class: "emq-table-footer" }

import { getOccupyOrderList, occupySettelment } from '@/api/operation'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import { dateFormat, throttleBtn } from '@/common/tools'
import CommonPagination from '@/components/commonPagination.vue'
import EvseOrderPaymentStatus from '@/components/EvseOrderPaymentStatus.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { Ref } from 'vue'
import SelectOperator from '@/components/SelectOperator.vue'
import SelectStation from '@/components/SelectStation.vue'
import LinkStation from '@/components/Links/LinkStation.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'
import LinkUser from '@/components/Links/LinkUser.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'
import LinkOrder from '@/components/Links/LinkOrder.vue'
import SelectEvse from '@/components/SelectEvse.vue'
import { ElMessage, ElMessageBox } from 'element-plus'

import { OrderTransactState } from '@/types/types'


import { defineComponent, ref, computed, defineProps } from 'vue'
import dayjs from 'dayjs'
import SelectUser from '@/components/SelectUser.vue'
import { formToJSON } from 'axios'
import PermissionLink from '@/components/PermissionLink.vue'

const __default__ = defineComponent({
  name: 'OccupyOrders',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  stationID: {
    type: String,
    default: '',
  },
  userID: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Evses')
const searchDateTime = ref<Array<Date>>([])

const showDialog = ref(false)
const showMoreQuery = ref(false)
const showOperator: Ref<undefined | Record<string, any>> = ref(undefined)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({
  payState: 0,
})
const { orderStates, getCurrencySymbol } = useProtocolEnums()
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('operators-detail')



const isStation = computed(function () {
  return (
    (props.stationID != '' && props.stationID != '0') || (props.userID != '' && props.userID != '0')
  )
})

const settelment = async (row: any) => {
  await ElMessageBox.confirm(t('Order.occupySettlementTip'), {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    type: 'warning',
  })

  try {
    await occupySettelment({ id: row.id })
    ElMessage.success(t(`Base.opSuccess`))
  } catch (error) {
    console.error('command:', error)
  }
}
const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadTableData({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  searchDateTime.value = []
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { userId, orderId, stationId, evseId, operatorId, beginTime, endTime, payState } = params
  newParams = {
    evseId: evseId || undefined,
    stationId: stationId || undefined,
    operatorId: operatorId || undefined,
    userId: userId || undefined,
    orderId: orderId || undefined,
    beginTime: beginTime || undefined,
    endTime: endTime || undefined,
    payState: payState || undefined,
  }
  return newParams
}

const loadTableData = async (_params = {}) => {
  lockTable.value = true

  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
    // userId: props.userID,
  }
  if (isStation.value) {
    sendParams.stationId = props.stationID
  }
  if (sendParams.stationId == '') {
    sendParams.stationId = '0'
  }
  if (sendParams.userId == '') {
    sendParams.userId = '0'
  }
  if (searchDateTime.value.length) {
    sendParams.beginTime = dayjs(searchDateTime.value[0]).unix()
    sendParams.endTime = dayjs(searchDateTime.value[1]).unix()
  }

  try {
    const { list = [], pageReply = {} } = await getOccupyOrderList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadTableData)
loadTableData()

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isStation))
      ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          class: "search-wrapper",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectUser, {
                      modelValue: fuzzyParams.value.userId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.userId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectStation, {
                      modelValue: fuzzyParams.value.stationId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.stationId) = $event)),
                      operatorID: fuzzyParams.value.operatorId
                    }, null, 8, ["modelValue", "operatorID"])
                  ]),
                  _: 1
                }, 16),
                _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(SelectEvse, {
                      modelValue: fuzzyParams.value.evseId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.evseId) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 16),
                (showMoreQuery.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(SelectOperator, {
                            modelValue: fuzzyParams.value.operatorId,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.operatorId) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: fuzzyParams.value.orderId,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fuzzyParams.value.orderId) = $event)),
                            placeholder: _ctx.$t('Order.orderID'),
                            clearable: "",
                            onClear: handleSearch
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }, 16),
                      _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: searchDateTime.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchDateTime).value = $event)),
                            type: "datetimerange",
                            "range-separator": "-",
                            "start-placeholder": _ctx.$t('Base.beginTime'),
                            "end-placeholder": _ctx.$t('Base.endTime')
                          }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
                        ]),
                        _: 1
                      }, 16)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      plain: "",
                      icon: _unref(Search),
                      onClick: handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_button, {
                      icon: _unref(RefreshLeft),
                      onClick: handleReset
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                      ]),
                      _: 1
                    }, 8, ["icon"]),
                    _createVNode(_component_el_tooltip, {
                      content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          class: "icon-button",
                          plain: "",
                          icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["content"])
                  ]),
                  _: 1
                }, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onKeyup"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_radio_group, {
          class: "legend-select",
          modelValue: fuzzyParams.value.payState,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((fuzzyParams.value.payState) = $event)),
          onChange: handleSearch,
          disable: lockTable.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, {
              label: _unref(OrderTransactState).OTS_UNKNOWN
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.all')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(OrderTransactState).OTS_PAY_PENDING
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Order.payStatePayPending')), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_radio_button, {
              label: _unref(OrderTransactState).OTS_PAY_SUCCESS
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Order.payStatePaySuccess')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "disable"]),
        _hoisted_4,
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "id",
            label: _ctx.$t('Order.orderID'),
            width: "160",
            align: "center",
            fixed: ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "orderId",
            width: "160",
            label: _ctx.$t('Order.chargingOrder'),
            fixed: ""
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(LinkOrder, {
                      id: row.orderId,
                      name: row.orderId
                    }, null, 8, ["id", "name"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "stationName",
            width: "150",
            label: _ctx.$t('Order.location')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(LinkStation, {
                      id: row.stationId,
                      name: row.stationName
                    }, null, 8, ["id", "name"]),
                    _hoisted_11,
                    _createVNode(LinkOperator, {
                      id: row.operatorId,
                      name: row.operatorName
                    }, null, 8, ["id", "name"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "evseId",
            width: "150",
            label: _ctx.$t('Order.evse')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(LinkEvse, {
                      id: row.evseId,
                      name: row.connectorName
                    }, null, 8, ["id", "name"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "userName",
            width: "120",
            label: _ctx.$t('Order.user')
          }, {
            default: _withCtx(({ row }) => [
              (row?.groupId != '0' && row?.groupId != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(row.groupName), 1)
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(LinkUser, {
                        id: row.userId,
                        name: row.userName
                      }, null, 8, ["id", "name"])
                    ])
                  ]))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "chargingbeginTime",
            width: "150",
            label: _ctx.$t('Order.occupyRangeTime')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (row.startTime > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_unref(dateFormat)(Number(row.startTime) * 1000)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, "-")),
                  (row.stopTime > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(dateFormat)(Number(row.stopTime) * 1000)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "pricing",
            "min-width": "150",
            label: _ctx.$t('Order.occupyPricing')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('Operation.freeOccupyTime')) + ": " + _toDisplayString(row.pricing.freeTime), 1),
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('Operation.maxOccupyFee')) + ": " + _toDisplayString(row.pricing.maxFee), 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(t)('Operation.occupyPrice')) + ": " + _toDisplayString(row.pricing.price), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "payState",
            label: _ctx.$t('Order.payState')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, [
                    _createVNode(EvseOrderPaymentStatus, {
                      state: row.payState
                    }, null, 8, ["state"])
                  ]),
                  _createElementVNode("span", _hoisted_34, [
                    (row.payTime > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_unref(dateFormat)(Number(row.payTime) * 1000)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_36, "-"))
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "amount",
            label: _ctx.$t('Order.occupyAmount'),
            width: "100",
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", null, _toDisplayString(row.amount), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(PermissionLink, {
                to: {
              name: 'order-detail',
              params: { id: row.orderId },
            },
                role: ['sessionInfo']
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    size: "small",
                    plain: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('Base.detail')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["to"]),
              _createVNode(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (settelment(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.settelment')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[8] || (_cache[8] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTableData
        }, null, 8, ["metaData"])
      ])
    ])
  ]))
}
}

})